import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFormstackComponent } from './simple-icons-formstack.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFormstackComponent ],
    exports:      [ SimpleIconsFormstackComponent ],
    bootstrap:    []
})
export class SimpleIconsFormstackModule {}
